import { useMemo } from 'react';

import { useRememberedAppMentions } from './app-mention-memory';
import { createAppMentionLinker } from './mention-links';

export const useAppMentionLinks = (
  text: string,
  { enabled }: { enabled: boolean }
) => {
  const apps = useRememberedAppMentions();
  const linkMentions = useMemo(
    () => createAppMentionLinker(apps.map(({ name }) => name)),
    [apps]
  );

  return enabled && text.includes('@') && apps.length > 0
    ? linkMentions(text)
    : text;
};
